import React, { Component } from "react"
import { Container } from "reactstrap";

class Form extends Component {
  componentDidMount() {
    if (typeof window !== "undefined") {
      const postscribe = require('postscribe');
      postscribe(this.ref, this.props.block.embedScript)
    }
  }

  render() {
    return(
      <Container>
				<div ref={ref => this.ref = ref} />
      </Container>
    )
  }
}

export default Form